import { buildCardField } from '@shared/data/cards/CardField';
import { FieldRecord } from '@shared/scenes/entity/types';
import { API } from '@shared/types/api';
import { User } from '@shared/types/user';

interface BuildFieldRecordProps {
  entity: API.WorkflowEntity;
  components: API.AnyComponent[];
  refs: NonNullable<NonNullable<API.ListWorkflowEntitiesQuery['list']>['refs']>;
  defaultData?: any;
  currentUser?: User;
}

export function buildFieldRecord({
  entity,
  components,
  refs,
  defaultData,
  currentUser,
}: BuildFieldRecordProps): FieldRecord {
  return components.reduce((record, component) => {
    record[component.id] = buildCardField({
      entity,
      component,
      refs,
      defaultData,
      currentUser,
    });
    return record;
  }, {});
}
